<template>
  <div>
    <!-- 客户列表 -->
    <baseBreadcrumb :page="$t('message.sassClientList')" :menu="$t('message.customerManagement')"></baseBreadcrumb>
    <!-- 主体 -->
    <div class="body">
      <!-- 搜索 -->
      <div class="search">
        <!-- 邮件查看 -->
        <div class="operation">
          <!-- 批量解冻 -->
          <el-button type="success" @click="batchUnfreezeClient(2)" v-if="isAuth(586)">
            {{ $t("message.batchFreeze") }}
          </el-button>
          <!-- 批量冻结 -->
          <el-button type="success" @click="batchUnfreezeClient(1)" class="dark" v-if="isAuth(585)">
            {{ $t("message.batchThawing") }}
          </el-button>
          <!-- 创建群组 -->
          <el-button type="success" @click="batchCreation" class="primary">
            {{ $t("message.createGroup") }}
          </el-button>
          <!-- 订单批量调整 -->
          <el-button type="success" @click="batchAdjustmentOfOrders" v-if="isAuth(532)" class="primary">
            {{ $t("message.batchAdjustmentOfOrders") }}
          </el-button>
          <!-- 配送单批量调整 -->
          <el-button type="success" @click="batchAdjustmentOfDeliveryOrders" v-if="isAuth(533)" class="primary">
            {{ $t("message.batchAdjustmentOfDeliveryOrders") }}
          </el-button>
          <!-- 客户分配 -->
          <el-button type="success" @click="customerAllocation" v-if="isAuth(443)">
            {{ $t("message.customerAllocation") }}
          </el-button>
          <!-- 分配业务 -->
          <!-- <el-button type="primary" class="primary" @click="allot('y')" v-if="isAuth(443)">
            {{ $t("message.distributionService") }}
          </el-button> -->
          <!-- 分配采购 -->
          <!-- <el-button type="primary" class="primary" @click="allot('g')" v-if="isAuth(443)">
            {{ $t("message.allocationPurchase") }}
          </el-button> -->
          <!-- 月预估下单额 -->
          <el-button type="primary" class="primary" @click="targetAmount" v-if="isAuth(527)">
            {{ $t("message.estimatedMonthlyOrderAmount") }}
          </el-button>
        </div>
        <div class="row">
          <!-- 客户ID -->
          <div class="item">
            <el-input v-model="datas.id" :placeholder="$t('message.userID')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 子账号ID -->
          <div class="item">
            <el-input v-model="datas.children_id" :placeholder="$t('message.subaccountID')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 人员范围 -->
          <div class="item">
            <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
          </div>
          <div class="item">
            <!--  全体人员-->
            <el-select v-model="datas.admin_id" :placeholder="$t('message.specificPersonnel')" filterable clearable>
              <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 客户名 -->
          <div class="item">
            <el-input v-model="datas.realname" :placeholder="$t('message.userName')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 手机号-->
          <div class="item">
            <el-input v-model="datas.mobile" :placeholder="$t('message.phoneNumber')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 邮箱 -->
          <div class="item">
            <el-input v-model="datas.email" :placeholder="$t('message.email')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 采购 -->
          <div class="item">
            <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
              <el-option v-for="item in g" :label="item.realname" :value="item.id" :key="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 业务 -->
          <div class="item">
            <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
              <el-option v-for="item in y" :label="item.realname" :value="item.id" :key="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 配货员 -->
          <div class="item">
            <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
              <el-option v-for="item in p" :label="item.realname" :value="item.id" :key="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="btn">
            <!-- 搜索 -->
            <el-button type="primary" @click="search">
              {{ $t("message.search") }}
            </el-button>
            <!-- 重置 -->
            <el-button @click="reset">
              {{ $t("message.reset") }}
            </el-button>
            <!-- 高级筛选 -->
            <el-button @click="showSearch = !showSearch" v-if="!showSearch">
              {{ $t("message.advancedFilter") }}
              <i class="el-icon-caret-right"></i>
            </el-button>
            <!-- 收起 -->
            <el-button @click="showSearch = !showSearch" v-else type="primary">
              {{ $t("message.putAway") }}
              <i class="el-icon-caret-top"></i>
            </el-button>
          </div>
          <!-- 操作 -->
        </div>
      </div>
      <!-- 高级筛选 -->
      <el-collapse-transition>
        <div class="advancedScreening" v-show="showSearch">
          <advancedScreening ref="advancedScreening" />
        </div>
      </el-collapse-transition>
      <!-- 列表 -->
      <div class="table" v-if="show">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" @selection-change="handleSelectionChange"
          ref="multipleTable" @cell-click="labelSelection" size="small">
          <el-table-column type="selection" width="50" align="center">
          </el-table-column>
          <!-- 客户ID -->
          <el-table-column align="center" label="NO" prop="rowNumber" width="50">
          </el-table-column>
          <!-- 客户-->
          <el-table-column align="center" :label="$t('message.user')" prop="id">
            <template slot-scope="scope">
              <p>ID:{{ scope.row.id }}</p>
              <p>{{ scope.row.realname }}</p>
              <p>
                <attributeName :name="scope.row.currentAttribute.name" />
                <span v-if="scope.row.user1688_account != false"
                  style="color: #b4272d;font-size: 14px;font-weight: 600;">1688</span>
              </p>
            </template>
          </el-table-column>
          <!-- 客户登录名 -->
          <el-table-column align="center" :label="$t('message.customerLoginName')" prop="username">
          </el-table-column>
          <!-- 客户等级 -->
          <el-table-column align="center" :label="$t('message.clientGrade')" prop="user_level.level_name">
          </el-table-column>
          <!-- 操作员 -->
          <el-table-column align="center" :label="$t('message.operator')" width="120">
            <template slot-scope="scope">
              <div class="name">
                <span>{{ $t("message.salesman") }}:</span>{{ scope.row.y_admin != null ? scope.row.y_admin.realname : ''
                }}
              </div>
              <div class="name">
                <span>{{ $t("message.buyer") }}:</span>{{ scope.row.g_admin != null ? scope.row.g_admin.realname : '' }}
              </div>
              <div class="name">
                <span>{{ $t("message.distributionMember") }}:</span>
                {{ scope.row.p_admin != null ? scope.row.p_admin.realname : '' }}
              </div>
            </template>
          </el-table-column>
          <!-- 客户状态 -->
          <!-- <el-table-column align="center" :label="$t('message.customerStatus')">
          </el-table-column> -->
          <!-- 余额(円) -->
          <el-table-column align="center" :label="$t('message.balance')" prop="balance">
          </el-table-column>
          <!-- 介绍人 -->
          <el-table-column align="center" :label="$t('message.introducer')" prop="gkuser">
          </el-table-column>
          <!-- 授权 -->
          <el-table-column align="center" :label="$t('message.authorized')" width="105px">

            <template slot-scope="scope">
              <!-- 配送单 -->
              <p>{{ $t('message.porder') }}：{{ scope.row.authorized == 1 ? $t('message.haveAuthorized')
                : $t('message.unauthorized') }}</p>
              <p>
                {{ $t('message.golden') }}：{{ scope.row.is_pay_authorized ? $t('message.haveAuthorized')
                  : $t('message.unauthorized') }}
              </p>
            </template>
          </el-table-column>
          <!-- 注册时间 -->
          <el-table-column align="center" :label="$t('message.registrationDate')" width="90" prop="created_at">
          </el-table-column>
          <!-- 最近下单时间 -->
          <el-table-column align="center" :label="$t('message.recentOrderPlacementTime')" width="90"
            prop="last_order.created_at">
          </el-table-column>
          <!-- 累计出货金额 -->
          <el-table-column align="center" :label="$t('message.accumulatedShipmentAmount')" width="80"
            prop="goods_amount">
          </el-table-column>
          <!-- 客户聊天 -->
          <el-table-column align="center" :label="$t('message.userChat')" width="70">
            <template slot-scope="scope">
              {{ scope.row.chatwork ? 'chatwork' : 'rakuchat' }}
            </template>
          </el-table-column>
          <!-- 会员到期时间 -->
          <el-table-column align="center" :label="$t('message.expirationTimeOfMembership')" width="90"
            prop="last_pay_vip.free_end">
          </el-table-column>
          <!-- 最近访问时间 -->
          <el-table-column align="center" :label="$t('message.lastVisitTime')" width="90"
            prop="user_extend.last_active_time">
          </el-table-column>
          <!-- 客户备注 -->
          <el-table-column align="center" :label="$t('message.userBeikao')" prop="user_extend.y_remark">
          </el-table-column>
          <!-- 运营备注 -->
          <el-table-column align="center" :label="$t('message.userRamrk')" prop="user_extend.desc" width="110">
            <template slot-scope="scope">
              <el-input type="textarea" v-model="scope.row.user_extend.desc" @blur="updateDesc(scope.row)"
                v-if="isAuth(558)"></el-input>
              <span v-else>{{ scope.row.user_extend.desc }}</span>
            </template>
          </el-table-column>
          <!-- 状态 -->
          <el-table-column align="center" :label="$t('message.status')" prop="account_status">
            <!-- <template slot-scope="scope">
              <span v-if="scope.row.is_forbid_order == 0">正常</span>
              <span v-else style="color: #b4272d">禁止下单</span>
            </template> -->
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')">
            <template slot-scope="scope">
              <!-- 分配 -->
              <p style="margin-bottom: 10px">
                <el-button size="small" type="primary" class="primary" @click="allocation(scope.row)"
                  v-if="isAuth(443)">
                  {{ $t("message.allocation") }}
                </el-button>
              </p>
              <!-- 详情 -->
              <p style="margin-bottom: 10px" v-if="isAuth(526)">
                <router-link
                  :to="'/user/basicInformation?userID=' + scope.row.id + '&encryption=' + $md5(scope.row.id + '')"
                  target="_blank">
                  <el-button size="small" type="primary" class="dark">
                    {{ $t("message.detail") }}
                  </el-button>
                </router-link>
              </p>
              <!-- 绑定讲师 -->
              <p>
                <el-button size="small" type="primary" class="success" @click="boundInstructor(scope.row)"
                  v-if="isAuth(502)">
                  {{ $t("message.boundInstructor") }}
                </el-button>
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <!-- 批量分配客户 -->
      <customerAllocation ref="customerAllocation" :selectList="selectList" :personnelData="personnelData" />
      <!-- 批量分配 -->
      <batchAllocation ref="batchAllocation" :selectList="selectList" :personnelData="personnelData" />
      <!-- 单个分配 -->
      <singleAllocation ref="singleAllocation" :allotVal="allotVal" :personnelData="personnelData" />
      <!-- 讲师绑定 -->
      <setGkUser ref="setGkUser" :ids="ids" :gk="gkuser" />
      <!-- 订单批量调整 -->
      <batchAdjustmentOfOrders ref="batchAdjustmentOfOrders" :selectList="selectList" :personnelData="personnelData" />
      <!-- 配送单批量调整 -->
      <batchAdjustmentOfDeliveryOrders ref="batchAdjustmentOfDeliveryOrders" :selectList="selectList"
        :personnelData="personnelData" />
      <!-- cw 确认创建 -->
      <cw ref="cw" :cwData="cwData" :selectList="selectList" />
    </div>
  </div>
</template>

<script>
import batchAllocation from "./components/batchAllocation";
import singleAllocation from "./components/singleAllocation";
import advancedScreening from "./components/advancedScreening";
import setGkUser from './components/setGkUser'
import customerAllocation from './components/customerAllocation'
import batchAdjustmentOfOrders from './components/batchAdjustmentOfOrders'
import batchAdjustmentOfDeliveryOrders from './components/batchAdjustmentOfDeliveryOrders'
import cw from './components/cw'
export default {
  components: { batchAllocation, singleAllocation, advancedScreening, setGkUser, customerAllocation, batchAdjustmentOfOrders, batchAdjustmentOfDeliveryOrders, cw },
  data() {
    return {
      datas: {
        page: 1,
        pageSize: 10,
        id: "",
        realname: "",
        admin_id: "",
        org_id: "",
        from_sass: 1
      },
      userList: [],
      tableData: [],
      total: 0,
      selectList: [],
      show: true,
      showSearch: false,
      // 单个 分配
      allotVal: {},
      // 设置讲师用
      ids: [],
      gkuser: '',

      cwData: [],// cw窗间前数据预览
    };
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
    personnelData() {
      return this.$store.state.authWorkGroupAdmin
    },
  },
  created() {
    this.clientList();

  },
  methods: {

    clientList() {
      this.$api.clienteleApi.clientList(this.datas).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.admin_id = "";
      this.datas.org_id = data.id;
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.clientList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.clientList();
    },
    // 搜索
    search() {
      let data = this.$refs.advancedScreening.option(false);
      let isDatas = {
        page: 1,
        pageSize: this.datas.pageSize,
        id: this.datas.id,
        realname: this.datas.realname,
        admin_id: this.datas.admin_id,
        email: this.datas.email,
        mobile: this.datas.mobile,
        org_id: this.datas.org_id,
        children_id: this.datas.children_id,
        y_id: this.datas.y_id,
        p_id: this.datas.p_id,
        g_id: this.datas.g_id,
        from_sass: 1,
        ...data
      }
      this.datas = isDatas
      this.clientList();
    },
    // 重置
    reset() {
      this.datas = {
        page: 1,
        pageSize: 10,
        id: "",
        realname: "",
        admin_id: "",
        CLIENT_ATTR: [],
        CLIENT_TYPE: [],
        org_id: "",
        email: '',
        realname: '',
        mobile: '',
        subaccountID: '',
        y_id: '',
        p_id: '',
        g_id: '',
        from_sass: 1
      };
      this.$refs.advancedScreening.option(true);
      this.$refs.cascader.orgId = [];
      this.userList = [];
      this.$forceUpdate();
      this.clientList();
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
    //分配
    allot(type) {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.$refs.batchAllocation.dialogVisible = true;
      this.$refs.batchAllocation.allot(type);
    },
    // 单个分配
    allocation(item) {
      this.allotVal = {
        user_id: [item.id],
        y_id: item.y_id,
        g_id: item.g_id,
        p_id: item.p_id,
      };
      this.$refs.singleAllocation.dialogVisible = true;
    },
    // 设置讲师
    boundInstructor(item) {
      this.ids = [item.id]
      this.gkuser = item.gkuser
      this.$refs.setGkUser.dialogVisible = true
    },
    //客户分配
    customerAllocation() {
      this.$refs.customerAllocation.dialogVisible = true
    },
    //标记目标额
    targetAmount() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        user_id: [],
        predict_order_amount: ''
      }
      this.selectList.forEach(item => {
        datas.user_id.push(item.id)
      })
      this.$prompt('月预估下单额', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^([0-9]\d*\.?\d{0,3})?.*$/,
        inputErrorMessage: '格式不正确'
      }).then(({ value }) => {
        datas.predict_order_amount = value
        this.$api.clienteleApi.targetAmount(datas).then((res) => {
          this.$message.success(res.msg)
          this.clientList();
        })
      }).catch(() => {
      });
    },
    //订单批量调整
    batchAdjustmentOfOrders() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      if (this.selectList.length > 1)
        return this.$message.error('只能单个进行批量调整');
      this.$refs.batchAdjustmentOfOrders.dialogVisible = true
    },
    // 配送单批量调整
    batchAdjustmentOfDeliveryOrders() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      if (this.selectList.length > 1)
        return this.$message.error('只能单个进行批量调整');
      this.$refs.batchAdjustmentOfDeliveryOrders.dialogVisible = true
    },
    //运营备注
    updateDesc(item) {
      let datas = {
        user_id_set: [item.id],
        desc: item.user_extend.desc
      }
      this.$api.clienteleApi.updateDesc(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    //cw批量建群
    batchCreation() {
      if (this.selectList == false) return this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        user: []
      }
      this.selectList.forEach(item => {
        datas.user.push(item.id)
      })

      this.$api.noticeApi.clusterPreview(datas).then((res) => {
        this.cwData = res.data
        this.$refs.cw.dialogVisible = true
      })


    },
    // 批量解冻
    batchUnfreezeClient(type) { //1解冻  2 冻结
      if (this.selectList == false) return this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        ids: []
      }
      this.selectList.forEach(item => {
        datas.ids.push(item.id)
      })
      console.log(type);

      this.$confirm(
        type == 1 ?
          this.$t("message.willTheSelectedCustomerSAccountBeUnfrozen") : this.$t("message.willTheSelectedCustomerSAccountBeFrozen"),
        // 是否将对选中的客户进行账号解冻,  是否将对选中的客户进行账号冻结
        // 提示
        this.$t("message.prompt"),

        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          if (type == 1) {
            this.$api.clienteleApi.batchUnfreezeClient(datas).then((res) => {
              this.$message.success(res.msg)
              this.clientList();
            });
          }
          else {
            this.$api.clienteleApi.batchFreezeClient(datas).then((res) => {
              this.$message.success(res.msg)
              this.clientList();
            });
          }

        })
        .catch(() => { });
    },
  },
};
</script>

<style lang='scss' scoped>
.search {
  margin-bottom: 24px;
  position: relative;

  .row {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 16px;

    .item {
      width: 180px;
      margin-right: 24px;
      margin-bottom: 10px;
    }
  }

  .operation {
    position: absolute;
    top: -85px;
    right: 0
  }
}

.advancedScreening {
  margin-bottom: 24px;
}

/deep/.el-textarea__inner {
  padding: 0;
  min-height: 100px !important;
}
</style>